var generic = generic || {};
var site = site || {};

/**
 * attached
 * _response
 * _rewards
 * _getImagePath
 * _callback
 * _fetch
 * _setMemberPoints
 * responseHandler
 * get
 * redeem
 * getSitesForReward
 * getProduct
 * destroyCache
 * filter
 * tierToLink
 */

(function ($) {
  'use strict';

  Drupal.behaviors.purePrivilegeRewardsV1 = {
    attached: false,
    _response: undefined,
    _rewards: undefined,

    _getImagePath: function (reward) {
      return '/media/images/pure_privilege/rewards/' + reward.rewardCode + '.jpg';
    },

    _callback: function (callback) {
      return typeof callback === 'function' ? callback : $.noop;
    },

    _fetch: function (method, params, callback) {
      var self = this;

      if (typeof callback !== 'function') {
        callback = $.noop;
      }

      return generic.jsonrpc.fetch({
        method: method,
        params: [params],
        onSuccess: function (jsonRpcResponse) {
          // var data = jsonRpcResponse.getData();
          var data = jsonRpcResponse.getValue();

          callback(null, data);
        },
        onFailure: function (jsonRpcResponse) {
          var errors = jsonRpcResponse.getError();
          var response;

          try {
            if ($.isArray(errors.data.messages)) {
              response = errors.data.messages;
            } else {
              response = [{ text: errors.message }];
            }
          } catch (e) {
          }

          try {
            generic.overlay.launch({
              content: errors.data.messages[0].text
            });
            console.error(method, params, errors);
          } catch (e) {
          }
          callback(response);
        }
      });
    },

    _setMemberPoints: function (newPoints) {
      var self = this;

      try {
        if (!newPoints || $.trim(newPoints) === '') {
          newPoints = 0;
        }

        self._response.member_info.derived_values.point_balance = newPoints;
      } catch (e) {
        self._response.member_info.derived_values.point_balance = 0;
      }
    },

    responseHandler: function (options, callback) {
      var self = this;
      // Build the response, handle various options.
      var response = $.extend(true, {}, self._response);
      var rewards, memberRewards, member;

      try {
        member = response.member_info;
        if (typeof member.derived_values.point_balance === 'undefined') {
          member = null;
        }
      } catch (e) {
        member = null;
      }
      try {
        memberRewards = response.user_rewards.rewards.rewardCodes;
      } catch (e) {
        memberRewards = null;
      }

      // Add disabled property for items that the user cannot redeem.
      _.each(response.full_catalog.rewards, function (reward, i) {
        reward.disabled = true;
        reward.insufficientPoints = true;

        reward.rewardImage = self._getImagePath(reward);

        if (memberRewards && typeof memberRewards[reward.rewardCode] !== 'undefined' && memberRewards[reward.rewardCode] == 1 && member && member.derived_values.point_balance >= reward.rewardPoints) {
          reward.disabled = false;
          reward.insufficientPoints = false;
        }

        response.full_catalog.rewards[i] = reward;
      });

      // Assign products to tiers.
      if (options.filter) {
        response.full_catalog.rewards = self.filter(response.full_catalog.rewards);
      }

      try {
        rewards = response.full_catalog.rewards;
      } catch (e) {
      }

      callback(null, response, rewards, memberRewards, member);
    },

    get: function (options, callback) {
      var self = this;
      var defaults = {};
      var path = 'pure_privilege.getCombinedRewardsCatalog';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.full_catalog = 1;
      var signedIn = Number(site.userInfoCookie.getValue('signed_in')) === 1 || Number(site.userInfoCookie.getValue('csr_logged_in')) === 1;
      var urlArray = document.referrer.split('?');
      var returnPath = urlArray[0];
      var fileName = returnPath.substring(returnPath.lastIndexOf('/') + 1);

      defaults.params.force = signedIn && fileName === 'signin.tmpl' ? 1 : 0;
      // 1 = Active, 2 = Inactive, 3 = All
      defaults.params.rewards_active_type = 3;
      defaults.filter = true;

      // Passing Techmark API language_id & country_id Keys
      defaults.params.language_id = document.location.hostname.search('fr.aveda.ca') !== -1 ? Drupal.settings.common.tecmark_api.language_id.fr : '';
      defaults.params.country_id = Drupal.settings.common.tecmark_api && Drupal.settings.common.tecmark_api.country_id !== '' ? Drupal.settings.common.tecmark_api.country_id : '';
      options = $.extend(true, {}, defaults, options);
      options = $.extend(true, {}, defaults, options);

      // Check if we have a cached state.
      if (self._response) {
        return self.responseHandler(options, callback);
      }

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        // Cache rewards in an unfilitered state.
        self._response = response;
        self._rewards = response.full_catalog.rewards;

        self.responseHandler(options, callback);
      });
    },

    redeem: function (options, callback) {
      var self = this;
      var defaults = {};
      var path = 'pure_privilege.redeemReward';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.reward_code = 0;
      // defaults.params.siteNumber = 0;
      defaults.filter = true;

      options = $.extend(true, {}, defaults, options);

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        if ($.isPlainObject(response)) {
          // Update member points.
          // Yes, Available is misspelled coming from TecMark...
          self._setMemberPoints(response.totalAvaliablePoints);
        }

        callback(null, response);
      });
    },

    getSitesForReward: function (options, callback) {
      var self = this;
      // Get Salon sites for reward that has flag isRedeemableAtSite
      var defaults = {};
      var path = 'pure_privilege.getSitesForReward';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.reward_code = $.isPlainObject(options) ? 0 : options;

      options = $.extend(true, {}, defaults, options);

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        var INDEXED = {
          'countries': {},
          'states': {},
          'cities': {},
          'sites': {}
        };

        if (_.isArray(response.awardSites)) {
          _.each(response.awardSites, function (site) {
            if (typeof INDEXED.countries[site.country] === 'undefined') {
              INDEXED.countries[site.country] = [];
              INDEXED.countries[site.country].push(site.state);
            } else {
              if (INDEXED.countries[site.country].indexOf(site.state) === -1) {
                INDEXED.countries[site.country].push(site.state);
              }
            }

            if (typeof INDEXED.states[site.state] === 'undefined') {
              INDEXED.states[site.state] = [];
              INDEXED.states[site.state].push(site.city);
            } else {
              if (INDEXED.states[site.state].indexOf(site.city) === -1) {
                INDEXED.states[site.state].push(site.city);
              }
            }

            if (typeof INDEXED.cities[site.city] === 'undefined') {
              INDEXED.cities[site.city] = [];
              INDEXED.cities[site.city].push(site.siteNumber);
            } else {
              if (INDEXED.cities[site.city].indexOf(site.siteNumber) === -1) {
                INDEXED.cities[site.city].push(site.siteNumber);
              }
            }

            if (typeof INDEXED.sites[site.siteNumber] === 'undefined') {
              INDEXED.sites[site.siteNumber] = site;
            }
          });
        }

        callback(null, response, INDEXED);
        // responseHandler(options, callback);
      });
    },

    getProduct: function (rewardCode, callback) {
      var self = this;
      var found = false;

      callback = self._callback(callback);

      self.get(function (err, response, rewards) {
        // Iterate through the cached, unmodified version.
        $.each(self._rewards, function (index, reward) {
          var member;

          if (reward.rewardCode == rewardCode) {
            try {
              member = response.member_info;
            } catch (e) {
            }
            reward.tierLink = self.tierToLink(reward.tierName);
            callback(null, reward, member);
            found = true;

            return false;
          }
        });

        if (found === false) {
          callback('Reward not found.');
        }
      });
    },

    destroyCache: function () {
      var self = this;

      self._response = undefined;
      self._rewards = undefined;
    },

    filter: function (_rewards) {
      var self = this;
      var rewards = {};
      var _r = [];

      // Assign rewards to their respective tiers.
      $.each(_rewards, function (index, reward) {
        if (typeof rewards[reward.tierName] === 'undefined') {
          rewards[reward.tierName] = {
            className: self.tierToLink(reward.tierName),
            name: reward.tierName,
            points: reward.rewardPoints,
            products: []
          };
        }
        rewards[reward.tierName].products.push(reward);
      });

      // Convert the object back into an array.
      $.each(rewards, function (index, reward) {
        // If member, then filter our the products that should not be displayed.
        _r.push(reward);
      });

      return _r;
    },

    tierToLink: function (tierName) {
      return $.trim(tierName).toLowerCase().replace(/[^a-z\d]+/g, '-');
    },

    renderTemplate: function ($template) {
      var self = this;

      self.get(function (options, response, rewards, memberRewards, member) {
        // console.log(options, response, rewards, memberRewards, member);
        self._response = response;
        self._rewards = rewards;

        var $container = $template.find('.pure-privilege__rewards-tiers');
        var translations = $template.data('translations');
        var removeRedeem = [];

        if (translations.remove_redeem) {
          removeRedeem = translations.remove_redeem.split(',');
        }

        _.extend(translations, {
          address: $template.find('.pure-privilege__rewards-address').html(),
          shipping: $template.find('.pure-privilege__rewards-shipping').html()
        });

        // setup mailing address
        var $address = '';

        if (self._response.member_info.memberGeneral.cardNumber) {
          var $firstName = self._response.member_info.memberGeneral.firstName ? self._response.member_info.memberGeneral.firstName : '';
          var $lastName = self._response.member_info.memberGeneral.lastName ? self._response.member_info.memberGeneral.lastName : '';
          var $fullName = $firstName && $lastName ? $firstName + ' ' + $lastName + '<br />' : $firstName + $lastName + '<br />';
          var $addressLine1 = self._response.member_info.memberAddressInfo[0].addressLine1 ? self._response.member_info.memberAddressInfo[0].addressLine1 + '<br />' : '';
          var $addressLine2 = self._response.member_info.memberAddressInfo[0].addressLine2 ? self._response.member_info.memberAddressInfo[0].addressLine2 + '<br />' : '';
          var $city = self._response.member_info.memberAddressInfo[0].city ? self._response.member_info.memberAddressInfo[0].city : '';
          var $state = self._response.member_info.memberAddressInfo[0].state ? self._response.member_info.memberAddressInfo[0].state : '';
          var $postalCode = self._response.member_info.memberAddressInfo[0].postalCode ? self._response.member_info.memberAddressInfo[0].postalCode : '';
          var $addressLine3 = $city && $state ? $city + ', ' + $state + ' ' + $postalCode : $city + $state + ' ' + $postalCode;

          $address = $fullName + $addressLine1 + $addressLine2 + $addressLine3;
        }

        // setup current date
        var $date = new Date(Date.now());

        $date = $date.toLocaleString();

        // render elements
        _.each(self._rewards, function (tier) {
          var $tier = $('<div class="tier" data-tier="' + tier.className + '" data-points="' + tier.points + '"><a class="anchor" id="' + tier.className + '"></a></div>');
          var $tierHeader = $('<div class="tier__header"><span>' + tier.name + '</span> ' + tier.points + ' ' + translations.points + '</div>');
          var $tierProducts = $('<div class="tier__products"><div class="carousel-controls"></div></div>');

          // build product template
          _.each(tier.products, function (product) {
            // console.log(product);
            var redeemButton = '<a href="#" class="button tier__products-product__redeem" data-reward-code="' + product.rewardCode + '" data-redeemable-site="' + product.isRedeemableAtSite + '">' + translations.redeem + '</a>';

            if ($.inArray(product.rewardCode.toString(), removeRedeem) > -1) {
              redeemButton = '';
            }
            var $product = $('' +
              '<div class="tier__products-product" data-reward-code="' + product.rewardCode + '">' +
              '<div class="tier__products-product__image-wrapper">' +
                '<div class="tier__products-product__description hidden">' + product.rewardDescription + '</div>' +
                '<img data-lazy="' + product.rewardImage + '" class="tier__products-product__image" />' +
              '</div>' +
              '<div class="tier__products-product__name">' + product.rewardName + '</div>' +
              '<a href="#" class="tier__products-product__description-toggle"><span class="show">' + translations.view + '</span><span class="hide">' + translations.hide + '</span> ' + translations.description + '</a>' +
              redeemButton +
              '</div>' +
            '');

            $product.appendTo($tierProducts);

            // setup Description toggle
            var $descToggle = $product.find('.tier__products-product__description-toggle');

            $descToggle.click(function () {
              var $description = $(this).siblings('.tier__products-product__image-wrapper').find('.tier__products-product__description');

              $description.toggleClass('hidden');
              $(this).toggleClass('active');

              return false;
            });

            // create reward confirmation display
            if (self._response.member_info.memberGeneral.cardNumber) {
              var $redeem = $('' +
                '<div class="tier__products-product-redeem hidden">' +
                '<div class="tier__products-product-redeem__header">' +
                '<h2 class="step1"><div class="total-points">' + translations.total + ' <span class="points">' + self._response.member_info.derived_values.point_balance + '</span></div>' + translations.step1a + '</h2>' +
                '<h2 class="step2 hidden"><div class="total-points">' + translations.total + ' <span class="points">' + self._response.member_info.derived_values.point_balance + '</span></div>' + translations.step1b + '</h2>' +
                '</div>' +
                '<table class="tier__products-product-redeem__table">' +
                '<tr>' +
                '<th>' + translations.tier + '</th>' +
                '<th colspan="2">' + translations.reward + '</th>' +
                '<th>' + translations.points + '</th>' +
                '<th colspan="2">' + translations.description + '</th>' +
                '</tr>' +
                '<tr>' +
                '<td><p>' + tier.name + '</p></td>' +
                '<td colspan="2"><p>' + product.rewardName + '</p><img src="' + product.rewardImage + '" /></td>' +
                '<td><p>' + tier.points + '</p></td>' +
                '<td colspan="2"><p class="description">' + product.rewardDescription + '</p></td>' +
                '</tr>' +
                '</table>' +
                '<p><a href="#" class="button tier__products-product__redeem-cancel step1">' + translations.change + '</a></p>' +
                '<div class="tier__products-product-redeem__selects step1"></div>' +
                '<div class="tier__products-product-redeem__header">' +
                '<h2 class="step1">' + translations.step2a + '</h2>' +
                '<h2 class="step2 hidden">' + translations.step2b + '</h2>' +
                '</div>' +
                '<div class="address-message step1">' + translations.address + '</div>' +
                '<p>' + $address + '</p>' +
                '<p>' + translations.date + ' ' + $date + '</p>' +
                '<p><a href="#" class="button tier__products-product__redeem-confirm step1" data-reward-code="' + product.rewardCode + '" data-redeemable-site="' + product.isRedeemableAtSite + '" data-site-number="">' + translations.confirm + '</a></p>' +
                translations.shipping +
                '</div>' +
                '');

              $redeem.appendTo($product);

              var $redeemCancelButton = $redeem.find('.tier__products-product__redeem-cancel');

              $redeemCancelButton.click(function () {
                $.colorbox.close();

                return false;
              });

              var $redeemConfirmButton = $redeem.find('.tier__products-product__redeem-confirm');

              $redeemConfirmButton.click(function () {
                var rewardCode = $(this).data('reward-code');
                var $confirmWindow = $(this).parents('.tier__products-product-redeem');
                var siteNumber = $(this).data('site-number');
                var isRedeemableAtSite = $(this).data('redeemable-site');
                var options = {
                  reward_code: rewardCode
                };

                if (!!isRedeemableAtSite && !!siteNumber) {
                  options.siteNumber = siteNumber;
                }

                self.redeem({
                  params: options
                }, function () {
                  $(document).trigger('pure_privilege.loaded', [self._response.member_info]);
                  $template.find('.tier__products-product-redeem__header .points').text(self._response.member_info.derived_values.point_balance);
                  $confirmWindow.find('.tier__products-product-redeem__header .points').text(self._response.member_info.derived_values.point_balance);
                  $confirmWindow.find('.step1').addClass('hidden');
                  $confirmWindow.find('.step2').removeClass('hidden');
                  $.colorbox.resize();
                });

                return false;
              });
            }

            // setup Redeem button
            var $redeemButton = $product.find('.tier__products-product__redeem');

            $redeemButton.click(function () {
              var signedIn = Number(site.userInfoCookie.getValue('signed_in')) === 1 || Number(site.userInfoCookie.getValue('csr_logged_in')) === 1;

              if (signedIn && !self._response.member_info.memberGeneral.cardAccountNumber && Drupal.settings.common.enable_pp_redeem_redirect_link) {
                window.location.pathname = '/account/pure_privilege/transactions.tmpl';

                return true;
              }
              if (!self._response.member_info.memberGeneral.cardNumber || Drupal.settings.common.tecmark_api) {
                // if user is not enrolled, show signin/join popup
                if (Drupal.settings.common.tecmark_api) {
                  window.open(Drupal.settings.common.tecmark_api.url + Drupal.settings.common.tecmark_api.pgm_id + '&award=' + $(this).data('reward-code'), '_RewardPopup', 700, 800, 'yes');

                  return true;
                }
                var $signin = $template.find('.pure-privilege__rewards-signin').clone(true).removeClass('hidden');

                generic.overlay.launch({
                  content: $signin
                });
              } else {
                var $details = $redeem.clone(true).removeClass('hidden');
                var $disable_state_dropdown = Drupal.settings.common.pure_privilege_disable_state ? Drupal.settings.common.pure_privilege_disable_state : '';

                if ($(this).data('redeemable-site')) {
                  var rewardCode = $(this).data('reward-code');

                  self.getSitesForReward({
                    params: { reward_code: rewardCode }
                  }, function (options, response, INDEXED) {
                    // console.log(INDEXED);

                    var $selects = $('<div class="selects"></div>');

                    $('<h3>' + translations.sites_message + '</h3>').appendTo($selects);

                    var $countries = $('<select id="country" name="country"><option value="" selected disabled>' + translations.country + '</option></select>');
                    var $states = $('<select id="state" name="state"><option value="" selected disabled>' + translations.state + '</option></select>');
                    var $cities = $('<select id="city" name="city"><option value="" selected disabled>' + translations.city + '</option></select>');
                    var $sites = $('<select id="site" name="site"><option value="" selected disabled>' + translations.site + '</option></select>');

                    _.each(Object.getOwnPropertyNames(INDEXED.countries), function (country) {
                      $('<option value="' + country + '">' + country + '</option>').appendTo($countries);
                    });

                    $countries.change(function () {
                      $states.empty();
                      $('<option value="" selected disabled>' + translations.state + '</option>').appendTo($states);

                      $cities.empty();
                      $('<option value="" selected disabled>' + translations.city + '</option>').appendTo($cities);

                      $sites.empty();
                      $('<option value="" selected disabled>' + translations.site + '</option>').appendTo($sites);

                      _.each(INDEXED.countries[$(this).val()], function (state) {
                        $('<option value="' + state + '">' + state + '</option>').appendTo($states);
                      });

                      if ($disable_state_dropdown) {
                        _.each(INDEXED.countries[$(this).val()], function (state) {
                          $("#state option[value='" + state + "']").attr('selected', true);
                        });
                        $states.change();
                      }
                    });

                    $states.change(function () {
                      $cities.empty();
                      $('<option value="" selected disabled>' + translations.city + '</option>').appendTo($cities);

                      $sites.empty();
                      $('<option value="" selected disabled>' + translations.site + '</option>').appendTo($sites);

                      _.each(INDEXED.states[$(this).val()], function (city) {
                        $('<option value="' + city + '">' + city + '</option>').appendTo($cities);
                      });
                    });

                    $cities.change(function () {
                      $sites.empty();
                      $('<option value="" selected disabled>' + translations.site + '</option>').appendTo($sites);

                      _.each(INDEXED.cities[$(this).val()], function (site) {
                        $('<option value="' + INDEXED.sites[site].siteNumber + '">' + INDEXED.sites[site].siteName + ', ' + INDEXED.sites[site].siteAddress + '</option>').appendTo($sites);
                      });
                    });

                    $sites.change(function () {
                      var siteNumber = $(this).val();

                      $details.find('.tier__products-product__redeem-confirm').attr('data-site-number', siteNumber);
                    });

                    $countries.appendTo($selects);
                    $states.appendTo($selects);
                    $cities.appendTo($selects);
                    $sites.appendTo($selects);

                    if ($disable_state_dropdown) {
                      $states.hide();
                    }

                    $details.find('.tier__products-product-redeem__selects').append($selects);
                    generic.overlay.launch({
                      content: $details
                    });
                  });
                } else {
                  generic.overlay.launch({
                    content: $details
                  });
                }
              }

              return false;
            });
          });
          // hide loading animation
          $template.find('.pure-privilege__rewards-loading').addClass('hidden');

          // place elements
          $tierHeader.appendTo($tier);
          $tierProducts.appendTo($tier);
          $tier.appendTo($container);

          // initialize carousel
          $tierProducts.slick({
            appendArrows: $tierProducts.find('.carousel-controls'),
            infinite: true,
            lazyLoad: 'progressive',
            slide: '.tier__products-product',
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        });

        // open reward details from reward code as hash
        var hash = window.location.hash;

        if (!!hash) {
          $('.tier__products-product__redeem[data-reward-code="' + hash.replace('#', '') + '"]').trigger('click');
        }
      });
    },

    init: function (context) {
      var self = this;
      var $template = $('.js-pure-privilege-rewards--v1', context);

      self.renderTemplate($template);
    },

    attach: function (context, settings) {
      var self = this;

      if (!self.attached) {
        self.init(context);
      }
      self.attached = true;
    }
  };
})(jQuery);
